import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Phone, Mail } from "lucide-react";
import { useLang } from "./ctx";
import { CONTACT } from "../../content";

export const MobileBar = () => {
  const { t } = useLang();
  const [show, setShow] = useState(false);
  useEffect(() => {
    const on = () => {
      const c = document.getElementById("contact");
      const nearContact = c ? c.getBoundingClientRect().top < window.innerHeight * 0.6 : false;
      setShow(window.scrollY > window.innerHeight * 0.8 && !nearContact);
    };
    on();
    window.addEventListener("scroll", on, { passive: true });
    return () => window.removeEventListener("scroll", on);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: 100 }} animate={{ y: 0 }} exit={{ y: 100 }}
          transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
          className="fixed inset-x-3 bottom-3 z-40 grid grid-cols-2 gap-2 rounded-full border border-stone-200 bg-[#FBFAF7]/90 p-1.5 shadow-[0_20px_50px_-20px_rgba(20,18,15,0.45)] backdrop-blur-xl lg:hidden"
          data-testid="mobile-action-bar"
        >
          <a href={CONTACT.phoneHref} data-testid="mobile-bar-call" className="flex items-center justify-center gap-2 rounded-full bg-[#14120F] py-3 text-sm text-white">
            <Phone size={15} strokeWidth={1.5} /> {t.contact.phone}
          </a>
          <a href={`mailto:${CONTACT.email}`} data-testid="mobile-bar-email" className="flex items-center justify-center gap-2 rounded-full py-3 text-sm text-stone-900">
            <Mail size={15} strokeWidth={1.5} /> {t.contact.email}
          </a>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
